import React from 'react'

import styles from '../../styles/modules/modal/modal.module.scss'

export const FormSeparator = () => {
  return <div className={styles.formSeparator}/>
}
